import { render, staticRenderFns } from "./BookingAreaProducts.vue?vue&type=template&id=45f8049a&scoped=true"
import script from "./BookingAreaProducts.vue?vue&type=script&lang=js"
export * from "./BookingAreaProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8049a",
  null
  
)

export default component.exports